import { createSlice } from "@reduxjs/toolkit";
import type { EditingHistoryActionTypes, EditingHistoryState } from "../types/editingHistoryState.types.ts";
import { EDITING_HISTORY_SLICE_NAME } from "../utils/storeUtils.ts";
import { currentReportSlice } from "./currentReportSlice.ts";

const initialState: EditingHistoryState = { versions: [], index: 0 };

const editingHistorySlice = createSlice({
  name: EDITING_HISTORY_SLICE_NAME,
  initialState,
  reducers: {
    baselined: (state, action: EditingHistoryActionTypes["baselined"]) => {
      state.versions[state.index] = action.payload;
    },
    recorded: (state, action: EditingHistoryActionTypes["recorded"]) => {
      state.versions = [...state.versions.slice(0, state.index + 1), action.payload];
      state.index = state.versions.length - 1;
    },
    moved: (state, action: EditingHistoryActionTypes["moved"]) => {
      state.index = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(currentReportSlice.actions.setCurrentReport, (state, action) =>
      state.reportId === action.payload.reportId ? state : { reportId: action.payload.reportId, versions: [], index: 0 }
    );
    builder.addCase(currentReportSlice.actions.reset, () => initialState);
  },
});
export default editingHistorySlice.reducer;
